export default __webpack_public_path__ + "static/media/18.ed59e336.jpg";